import request from '@/utils/request';
import {
  endpoints,
  catalogueTemplateEndpoint,
  datasetEndpoint,
} from '@/constants/urls';

const catalogueTemplates = (includeEnabled, includeDisabled) => {
  const params = {};

  const enabledFlags = [includeEnabled, includeDisabled];
  const allSet = enabledFlags.every((v) => v === enabledFlags[0]);

  if (!allSet) {
    if (includeEnabled) {
      params.enabled = true;
    }
    if (includeDisabled) {
      params.disabled = true;
    }
  }

  return request({
    method: 'GET',
    params,
    url: endpoints.CATALOGUE_TEMPLATES,
  });
};

const catalogueTemplate = (code) => request({
  url: catalogueTemplateEndpoint(code),
  method: 'GET',
});

const catalogue = (code) => request({
  url: `${datasetEndpoint(code)}/catalogue`,
  method: 'GET',
});

const CataloguesService = {
  catalogueTemplates,
  catalogueTemplate,
  catalogue,
};

export default CataloguesService;
